import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-works-details',
  templateUrl: './works-details.component.html',
  styleUrls: ['./works-details.component.scss']
})
export class WorksDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
